<header>
    <div class="top pt-1 pb-1 d-none d-lg-flex">
        <div class="container">
            <div class="row d-none d-lg-flex">
                <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-4">
                    <ul class="nav language mt-1">
                        <li class="nav-item ">
                            <div class="nav-link active lang" lang="th">th</div>
                        </li>
                        <li class="nav-item">
                            <div class="nav-link lang" lang="en">en</div>
                        </li>
                    </ul>
                </div>
                <div class="th col-6 col-sm-6 col-md-6 col-lg-7 col-xl-8 text-right">
                    <a class="test-drive" href="https://www.mgcars.com/th/TestDrive" role="button" id="webTestDrive">ทดลองขับเอ็มจี</a>
                    <a class="find-showroom" href="https://www.mgcars.com/th/Dealer"
                        role="button" id="webFindDealers">ค้นหาผู้จำหน่ายเอ็มจี</a>
                    <a class="find-charging-station" href="https://www.mgcars.com/th/innovation/ev/charging-station"
                        role="button" id="webFindCharger">ค้นหาสถานีชาร์จ</a>
                </div>
                <div class="en col-6 col-sm-6 col-md-6 col-lg-7 col-xl-8 text-right">
                    <a class="test-drive" href="https://www.mgcars.com/en/TestDrive" role="button">Test Drive</a>
                    <a class="find-showroom" href="https://www.mgcars.com/en/Dealer" role="button">Find a Showroom</a>
                    <a class="find-charging-station" href="https://www.mgcars.com/en/innovation/ev/charging-station"
                        role="button">Find a Charging Station</a>
                </div>
            </div>
        </div>
    </div>
    <div class="container main-menu pt-2 pb-2">
        <div class="row no-gutters align-items-center">
            <div class="col-6 col-lg-2">
                <a href="https://www.mgcars.com"><img src="https://www.mgcars.com/images/mg-logo.png"
                        class="img-fluid logo" alt="MG Cars"></a>
            </div>
            <div class="col-6 d-block d-lg-none position-relative">
                <!-- <a class="navbar-toggle-offcanvas-right toggle"><span></span></a> -->
                <a class="navbar-toggle-offcanvas-right toggle" data-bs-toggle="offcanvas" href="#rightMenu" role="button" aria-controls="rightMenu" id="rightMenuBT"><span></span></a>
            </div>
            <div class="col-lg-10 d-none d-lg-block" style="position: static;">
                <ul class="nav justify-content-end">
                    <li class="nav-item">
                        <a class="th nav-link " href="https://www.mgcars.com/th/Home" id="home">หน้าแรก</a>
                        <a class="en nav-link " href="https://www.mgcars.com/en/Home">HOME</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="th nav-link" href="JavaScript:void(0);" id="MGModelsDropdown" role="button" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" >รุ่นรถ
                        </a>
<!--                        <a class="en nav-link" href="JavaScript:void(0);" id="MGModelsDropdown" role="button" data-toggle="dropdown"-->
<!--                            aria-haspopup="true" aria-expanded="false">MG MODELS-->
<!--                        </a>-->
                        <div class="dropdown-menu w-100 mega-menu" aria-labelledby="MGModelsDropdown">
                            <div class="container pt-3 pb-3 pl-5 pr-5 text-center" id="carModel">
                                <div class="row">
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-zs/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/15/4cf06b81e873566073480a7481765365.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี แซดเอส"><span>นิว เอ็มจี
                                                แซดเอส</span></a>
                                    </div>
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/all-new-mg3/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/10/7f13af6b56bcb9ba8df7fade0b0d8956.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/ออล นิว เอ็มจี 3"><span>ออล นิว
                                                เอ็มจี 3</span></a>
                                    </div>
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-hs/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/13/052e4944ee7fd15de33ac4bd8be466bf.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี เฮชเอส"><span>นิว เอ็มจี
                                                เฮชเอส</span></a>
                                    </div>
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-hs-phev/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/17/00c331f187ccb99e1e26935e059f57a8.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี เฮชเอส พีเฮชอีวี"><span>นิว
                                                เอ็มจี เฮชเอส พีเฮชอีวี</span></a>
                                    </div>
                                    <div class="col-3 border-bottom  pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-zs-ev/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/4/be05bffd034f6ba969f354ec6ba39f33.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี แซดเอส อีวี"><span>นิว
                                                เอ็มจี แซดเอส อีวี</span></a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-ep/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/18/f840db7f856037122893d20738b13ff5.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี อีพี"><span>นิว เอ็มจี
                                                อีพี</span></a>
                                    </div>
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-extender-gc/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/12/576afc13776cfcd20ae946993215bf64.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี เอ็กซ์เทนเดอร์ จีซี"><span>นิว
                                                เอ็มจี เอ็กซ์เทนเดอร์ จีซี</span></a>
                                    </div>
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-extender-dc/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/14/0c05f5136ce0968cc2b419371285d045.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี เอ็กซ์เทนเดอร์ ดีซี"><span>นิว
                                                เอ็มจี เอ็กซ์เทนเดอร์ ดีซี</span></a>
                                    </div>
                                    <div class="col-3 border-bottom border-right pt-4">
                                        <a href="https://www.mgcars.com/th/mg-models/new-mg-v80/overview"><img
                                                src="https://www.mgcars.com/storage/upload/car_type/5/f7319cad9e97b3be37e2dd29e1f40e68.png"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/นิว เอ็มจี วีแปดสิบ"><span>นิว
                                                เอ็มจี วีแปดสิบ</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="th nav-link " href="https://onlinebooking.mgcars.com/" id="onlineBooking">จองออนไลน์</a>
                        <!--                        <a class="en nav-link " href="https://www.mgcars.com/en/Promotion">Promotion</a>-->
                    </li>
                    <li class="nav-item">
                        <a class="th nav-link " href="https://www.mgcars.com/th/Promotion" id="promotion">โปรโมชัน</a>
<!--                        <a class="en nav-link " href="https://www.mgcars.com/en/Promotion">Promotion</a>-->
                    </li>
                    <li class="nav-item">
                        <a class="th nav-link " href="https://www.mgcars.com/th/AfterSalesService" id="service">บริการหลังการขาย</a>
<!--                        <a class="en nav-link " href="https://www.mgcars.com/en/AfterSalesService">Services</a>-->
                    </li>
                    <li class="nav-item dropdown">
                        <a class="th nav-link " href="javascript:void(0)" id="InnovationsDropdown" role="button" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">นวัตกรรม</a>
<!--                        <a class="en nav-link " href="" id="InnovationsDropdown" role="button" data-toggle="dropdown"-->
<!--                            aria-haspopup="true" aria-expanded="false">Innovations</a>-->
                        <div class="dropdown-menu w-100 mega-menu" aria-labelledby="InnovationsDropdown">
                            <div class="container pt-3 pb-3 pl-5 pr-5 text-center">
                                <div class="row">
                                    <div class="col-3 border-right pt-4 position-relative">
                                        <a class="" href="https://www.mgcars.com/th/innovation/ismart"><img
                                                src="https://www.mgcars.com/images/menu/ismart.png"
                                                class="img-innovation" alt="MG i - SMART">
                                            <p>MG i - SMART</p>
                                        </a>
                                    </div>
                                    <div class="col-3 border-right pt-4 position-relative">
                                        <a class="" href="https://www.mgcars.com/th/innovation/britdynamic"><img
                                                src="https://www.mgcars.com/images/menu/Brit.png" class="img-innovation"
                                                alt="Brit Dynamic">
                                            <p>BRIT DYNAMIC</p>
                                        </a>
                                    </div>
                                    <div class="col-3 border-right pt-4 position-relative">
                                        <a class="" href="https://www.mgcars.com/th/innovation/adas"><img
                                                src="https://www.mgcars.com/images/adas/adas.png" class="img-innovation"
                                                alt="Adas">
                                            <p>ADAS</p>
                                        </a>
                                    </div>
                                    <div class="col-3 border-right pt-4 position-relative">
                                        <a class="" href="https://www.mgcars.com/th/innovation/ev"><img
                                                src="https://www.mgcars.com/images/menu/ev.png" class="img-innovation"
                                                alt="EV Innovation">
                                            <p>EV INNOVATION</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="th nav-link " href="#" id="NewsActivitiesDropdown" role="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">ข่าวสารและกิจกรรม
                        </a>
<!--                        <a class="en nav-link " href="#" id="NewsActivitiesDropdown" role="button"-->
<!--                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">NEWS & ACTIVITIES-->
<!--                        </a>-->
                        <div class="dropdown-menu w-100 mega-menu" aria-labelledby="NewsActivitiesDropdown">
                            <div class="th container p-3 text-right">
                                <a class="" href="https://www.mgcars.com/th/NewsActivities">ข่าวสาร</a>
                                <a class="ml-4 " href="https://www.mgcars.com/th/EventAndRoadshow">กิจกรรม</a>
                            </div>
                            <div class="en container p-3 text-right">
                                <a class="" href="https://www.mgcars.com/en/NewsActivities">News</a>
                                <a class="ml-4 " href="https://www.mgcars.com/en/EventAndRoadshow">Activities</a>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="th nav-link " href="javascript:void(0)" id="AboutMGDropdown" role="button" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">เกี่ยวกับเรา</a>
<!--                        <a class="en nav-link " href="" id="AboutMGDropdown" role="button" data-toggle="dropdown"-->
<!--                            aria-haspopup="true" aria-expanded="false">About MG</a>-->
                        <div class="dropdown-menu w-100 mega-menu" aria-labelledby="AboutMGDropdown">
                            <div class="th container p-3 text-right">
                                <a class="" href="https://www.mgcars.com/th/Overview">บทนำ</a>
                                <a class="ml-3 " href="https://www.mgcars.com/th/WhyMG">ทำไมจึงมีเอ็มจี </a>
                                <a class="ml-3 " href="https://www.mgcars.com/th/Heritage">ประวัติของเอ็มจี</a>
                            </div>
                            <div class="en container p-3 text-right">
                                <a class="" href="https://www.mgcars.com/en/Overview">OVERVIEW</a>
                                <a class="ml-3 " href="https://www.mgcars.com/en/WhyMG">WHY MG? </a>
                                <a class="ml-3 " href="https://www.mgcars.com/en/Heritage">HERITAGE</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</header>

<!-- ===================== -->
